<div class="row">
  <div class="col-2">
    <app-select [(ngModel)]="type" [options]="['berth', 'port', 'portofcall', 'location', 'portfacility', 'vessel',
    'pilotexemption', 'dangerousgood', 'dangerinformation', 'wastematerial', 'bunkerproduct', 'bunkerproductsupplier', 'bunkerlicense', 'terminal', 'quay', 'carrier', 'sizetype',
    'linerservice', 'terminalemail', 'exemption']"
      [formatter]="formatOption"
    (ngModelChange)="entry = undefined; searchResult = undefined"></app-select>
  </div>
  <div class="col">
    <app-search [(ngModel)]="searchResult" [searchFunction]="search" [inputFormatter]="searchResultFormatter"
    [minCharacters]="3" (ngModelChange)="entry = searchResult" placeholder="Find a {{type}}"></app-search>
  </div>
  @if (type !== 'dangerousgood') {
    <div class="col-auto">
      <button class="btn btn-info" type="button" (click)="newEntry()">
        @if (searchResult) {
          Duplicate
        }
        @if (!searchResult) {
          Add new
        }
        {{ type }}
      </button>
    </div>
  }
  @if (type === 'dangerousgood') {
    <div class="col-auto">
      <div class="dropdown">
        <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          @if (searchResult) {
            Duplicate
          }
          @if (!searchResult) {
            Add new
          }
          good
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" (click)="newDgEntry('chemical')">Chemical</a>
          <a class="dropdown-item" (click)="newDgEntry('containerGood')">Container good</a>
          <a class="dropdown-item" (click)="newDgEntry('gas')">Gas</a>
          <a class="dropdown-item" (click)="newDgEntry('oil')">Oil</a>
          <a class="dropdown-item" (click)="newDgEntry('solid')">Solid good</a>
        </div>
      </div>
    </div>
  }
</div>

@if (entry) {
  <div class="mt-5">
    <div class="declaration-block">
      <h2>{{ type | titlecase }} details</h2>
    </div>

    @switch (type) {
      @case ('berth') {
        <app-edit-berth [berth]="entry"></app-edit-berth>
      }
      @case ('terminal') {
        <app-edit-terminal [terminal]="entry"></app-edit-terminal>
      }
      @case ('quay') {
        <app-edit-quay [quay]="entry"></app-edit-quay>
      }
      @case ('port') {
        <app-edit-port [port]="entry"></app-edit-port>
      }
      @case ('portofcall') {
        <app-edit-port-of-call [portOfCall]="entry"></app-edit-port-of-call>
      }
      @case ('location') {
        <app-edit-location [location]="entry"></app-edit-location>
      }
      @case ('portfacility') {
        <app-edit-port-facility [portFacility]="entry"></app-edit-port-facility>
      }
      @case ('vessel') {
        <app-edit-vessel [vessel]="entry"></app-edit-vessel>
      }
      @case ('pilotexemption') {
        <app-edit-pilot-exemption [pilotExemption]="entry"></app-edit-pilot-exemption>
      }
      @case ('dangerousgood') {
        <app-edit-dangerous-good [dangerousGood]="entry"></app-edit-dangerous-good>
      }
      @case ('wastematerial') {
        <app-edit-waste-material [wasteMaterial]="entry"></app-edit-waste-material>
      }
      @case ('bunkerproduct') {
        <app-edit-bunker-product [bunkerProduct]="entry"></app-edit-bunker-product>
      }
      @case ('bunkerproductsupplier') {
        <app-edit-bunker-product-supplier [bunkerProductSupplier]="entry"></app-edit-bunker-product-supplier>
      }
      @case ('bunkerlicense') {
        <app-edit-bunker-license [bunkerLicense]="entry"></app-edit-bunker-license>
      }
      @case ('dangerinformation') {
        <app-edit-danger-information [dangerInformation]="entry"></app-edit-danger-information>
      }
      @case ('linerservice') {
        <app-edit-liner-service [linerService]="entry"></app-edit-liner-service>
      }
      @case ('terminalemail') {
        <app-edit-terminal-email [terminalEmail]="entry"></app-edit-terminal-email>
      }
      @case ('exemption') {
        <app-edit-exemption [exemptionInfo]="entry"></app-edit-exemption>
      }
      @case ('carrier') {
        <app-edit-carrier [carrier]="entry"></app-edit-carrier>
      }
      @case ('sizetype') {
        <app-edit-sizetype [sizetype]="entry"></app-edit-sizetype>
      }
    }
  </div>
}

@if (entry) {
  <div class="my-2 row justify-content-between">
    <div class="col-auto">
      @if (searchResult) {
        <button class="btn btn-danger" type="button" (click)="deleteEntry()" style="width: 10rem">
          Delete {{ type }}
        </button>
      }
    </div>
    @if (!searchResult) {
      <div class="col-auto">
        <button class="btn btn-info" type="button" (click)="addEntry()" style="width: 10rem">
          Add {{ type }}
        </button>
      </div>
    }
    @if (searchResult) {
      <div class="col-auto">
        <button class="btn btn-info" type="button" (click)="updateEntry()" style="width: 10rem">
          Save {{ type }}
        </button>
      </div>
    }
  </div>
}
